import { CommonModule, Location } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { MaterialModule } from '../../../material/material.module';
import { UserService } from '../../../shared/services/user.service';

@Component({
  selector: 'app-scout-details',
  imports: [CommonModule, MaterialModule],
  templateUrl: './scout-details.component.html',
  styleUrl: './scout-details.component.css'
})
export class ScoutDetailsComponent implements OnInit {
  isLoading = false;
  userId = '';
  userDetails: any = null;

  constructor(
    private route: ActivatedRoute,
    private userService: UserService,
    private location: Location
  ) {}

  ngOnInit(): void {
    this.userId = this.route.snapshot.paramMap.get('UserId') || '';
    this.loadUser();
  }

  back(): void {
    this.location.back();
  }

  loadUser(): void {
    if (!this.userId) {
      return;
    }

    this.isLoading = true;
    this.userService.getUser(this.userId).subscribe({
      next: (user) => {
        this.userDetails = user;
        this.isLoading = false;
      },
      error: () => {
        this.userDetails = null;
        this.isLoading = false;
      }
    });
  }

  getDisplayName(): string {
    if (!this.userDetails) {
      return '';
    }

    const firstName = this.userDetails.FirstName || this.userDetails.firstName || '';
    const lastName = this.userDetails.LastName || this.userDetails.lastName || '';
    const fullName = `${firstName} ${lastName}`.trim();

    if (fullName.length > 0) {
      return fullName;
    }

    return this.getUserEmail() || this.userId;
  }

  getUserEmail(): string {
    return this.userDetails?.Email || this.userDetails?.email || '';
  }

  getUserName(): string {
    return this.userDetails?.UserName || this.userDetails?.userName || '';
  }

  isLocked(): string {
    const value = this.userDetails?.IsLocked ?? this.userDetails?.isLocked;
    if (value === true) {
      return 'Yes';
    }

    if (value === false) {
      return 'No';
    }

    return '-';
  }
}
